import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Divider, Table, message } from 'antd';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Button } from '../../../components/buttons/buttons';
import LeadtoCam from '../Popup/LeadtoCam'
import ContecttoCam from '../Popup/ContecttoCam'
import CampaignTemplate from '../Popup/CampaignTemplate'
import { useExcryptedNavigation } from '../Filters/FilterConditions';
import { CampaignUpdate } from '../../../Api/Services/CampaignApiServices'
import { EmailTemplateIcon } from "../../../components/Icons/Icons";

const CamReports = ({ allLead, allContact, displayData, getCampaignData, refreshTrigger, tabKey }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [display, setDisplay] = useState(false)
    const [openUser, setOpenUser] = useState(false)
    const [openUser1, setOpenUser1] = useState(false)
    const [configType, setConfigType] = useState(false)
    const [openTemplate, setOpenTemplate] = useState(false)
    const [UserexportData, setUserExportData] = useState([])
    const [UserexportData1, setUserExportData1] = useState([])
    const [UserfilterDatas, setUserFilterDatas] = useState([])
    const [UserRemovealKeys, setUserRemovealKeys] = useState([])
    const [UserfilterDatas1, setUserFilterDatas1] = useState([])
    const [UserRemovealKeys1, setUserRemovealKeys1] = useState([])
    const [UserselectedRowKeys, setUserSelectedRowKeys] = useState([])
    const [UserselectedRowKeys1, setUserSelectedRowKeys1] = useState([])
    const { ExcryptedNavigation } = useExcryptedNavigation()
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    const ConfirmUser = async (formData, type, newData) => {
        setDisplay(true)
        let hideMessage;
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await CampaignUpdate(formData, displayData?.campaignId)
            if (response.status === 200) {
                message.success(`Selected ${type} have been successfully removed from the campaign`)
                hideMessage();
                setDisplay(false)
                if (type === "leads") {
                    setUserSelectedRowKeys(newData)
                    setUserRemovealKeys([])
                }
                if (type === "contacts") {
                    setUserSelectedRowKeys1(newData)
                    setUserRemovealKeys1([])
                }
                getCampaignData()
            }
        }
        catch (error) {
            hideMessage();
            setDisplay(false)
            message.error(error)
        }
    }
    const openTemplateFunction = (type) => {
        setOpenTemplate(!openTemplate)
        setConfigType(type)
    }
    const OpenUserTable = () => {
        setOpenUser(!openUser)
    }
    const OpenUserTable1 = () => {
        setOpenUser1(!openUser1)
    }
    const onSelectChange = (newSelectedRowKeys) => {
        setUserRemovealKeys(newSelectedRowKeys)
    };
    const onSelectChange1 = (newSelectedRowKeys) => {
        setUserRemovealKeys1(newSelectedRowKeys)
    };
    const UserDataRemoved = (type) => {
        const newData = UserselectedRowKeys.filter(item => !UserRemovealKeys.includes(item));
        const payload = { leads: (newData && newData.length > 0) ? newData.join(',') : null, }
        ConfirmUser(payload, type, newData)
    }
    const UserDataRemoved1 = (type) => {
        const newData = UserselectedRowKeys1.filter(item => !UserRemovealKeys1.includes(item));
        const payload = { contacts: (newData && newData.length > 0) ? newData.join(',') : null, }
        ConfirmUser(payload, type, newData)
    }
    const rowSelection = {
        selectedRowKeys: UserRemovealKeys,
        onChange: onSelectChange,
        getCheckboxProps: () => ({
            disabled: UserRemovealKeys1.length > 0,
        }),
    };
    const rowSelection1 = {
        selectedRowKeys: UserRemovealKeys1,
        onChange: onSelectChange1,
        getCheckboxProps: () => ({
            disabled: UserRemovealKeys.length > 0,
        }),
    };
    const usersTableColumns = [
        {
            title: 'Candidates Name',
            dataIndex: 'name',
            key: 'name',
            width: "45%",
            ellipsis: true,
        },
        {
            title: 'Designation',
            dataIndex: 'designation',
            key: 'designation',
            width: "20%",
            ellipsis: true,
        },
        {
            title: 'Sponsor Name',
            dataIndex: 'accountname',
            key: 'accountname',
            width: "35%",
            ellipsis: true,
        },
    ];
    const usersTableColumns1 = [
        {
            title: 'Resident Name',
            dataIndex: 'name',
            key: 'name',
            width: "45%",
            ellipsis: true,
        },
        {
            title: 'Designation',
            dataIndex: 'designation',
            key: 'designation',
            width: "20%",
            ellipsis: true,
        },
        {
            title: 'Sponsor Name',
            dataIndex: 'accountname',
            key: 'accountname',
            width: "35%",
            ellipsis: true,
        },
    ];
    const usersTableData = [];
    if (UserexportData !== undefined) {
        UserexportData.map((user) => {
            const matchedLead = displayData?.leadNames?.find(
                (lead) => lead && lead.leadPersonId === user.leads_id
            );
            const hasPermission = { isPresent: matchedLead?.leadPermission ?? false }
            return usersTableData.push({
                LeadData: hasPermission,
                key: user.leads_id,
                name: (<div className={`user-info_image ${hasPermission.isPresent ? "table_list_clicks" : ""}`} style={{
                    padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0,
                }}>
                    {user.leads_id && (user.lead_profile !== null && user.lead_profile
                        !== undefined && user.lead_profile !== "" ?
                        <figure>
                            <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={user.lead_profile} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag LeadIcon' style={{ flexShrink: 0, }}>
                            {user.first_name && user.first_name.slice(0, 1).toUpperCase()}
                        </span>
                    )}
                    {user.leads_id &&
                        <figcaption style={{
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden", // 👈 keeps ellipsis responsive
                        }}>
                            <div title={`${user.first_name} ${user.last_name}`} style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}>
                                {`${user.first_name} ${user.last_name}`}
                            </div>
                            <div className='entityemail' style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }} title={user?.primary_email}>
                                {user.primary_email}
                            </div>
                        </figcaption>
                    }
                </div>),
                accountname: (<div className={`${hasPermission.isPresent ? "table_list_clicks" : ""}`}>{user.account_name}</div>),
                designation: (<div className={`${hasPermission.isPresent ? "table_list_clicks" : ""}`}>{user.designation}</div>),
            });
        });
    }
    const usersTableData1 = [];
    if (UserexportData1 !== undefined) {
        UserexportData1.map((user) => {
            const matchedLead = displayData?.contactNames?.find(
                (lead) => lead && lead.contactPersonId === user.contacts_id
            );
            const hasPermission = { isPresent: matchedLead?.contactPermission ?? false }
            return usersTableData1.push({
                contactData: hasPermission,
                key: user.contacts_id,
                name: (<div className={`user-info_image ${hasPermission.isPresent ? "table_list_clicks" : ""}`} style={{
                    padding: "0px 0px 10px", display: "flex", alignItems: "center", minWidth: 0,
                }}>
                    {user.contacts_id && (user.contact_profile !== null && user.contact_profile
                        !== undefined && user.contact_profile !== "" ?
                        <figure>
                            <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={user.contact_profile} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag LeadIcon' style={{ flexShrink: 0, }}>
                            {user.first_name && user.first_name.slice(0, 1).toUpperCase()}
                        </span>
                    )}
                    {user.contacts_id &&
                        <figcaption style={{
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden", // 👈 keeps ellipsis responsive
                        }}>
                            <div title={`${user.first_name} ${user.last_name}`} style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}>
                                {`${user.first_name} ${user.last_name}`}
                            </div>
                            <div className='entityemail' style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }} title={user?.email}>
                                {user.email}
                            </div>
                        </figcaption>
                    }
                </div>),
                accountname: (<div className={`${hasPermission.isPresent ? "table_list_clicks" : ""}`}>{user.account_name}</div>),
                designation: (<div className={`${hasPermission.isPresent ? "table_list_clicks" : ""}`}>{user.designation}</div>),
            });
        });
    }
    useEffect(() => {
        if (refreshTrigger === tabKey) {
            if (displayData && allLead && allContact) {
                if (allLead) {
                    setUserSelectedRowKeys([])
                    setUserRemovealKeys([])
                    setUserSelectedRowKeys(displayData.leads ? displayData.leads.split(",").map(user => Number(user)) : [])
                    setUserExportData(allLead)
                    setUserFilterDatas(allLead);
                }
                if (allContact) {
                    setUserSelectedRowKeys1([])
                    setUserRemovealKeys1([])
                    setUserSelectedRowKeys1(displayData.contacts ? displayData.contacts.split(",").map(user => Number(user)) : [])
                    setUserExportData1(allContact)
                    setUserFilterDatas1(allContact);
                }
            }
        }
    }, [displayData, allLead, allContact, refreshTrigger, tabKey])
    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ fontWeight: "600", fontSize: 16 }}>Selected Candidates</div>
                <div style={{ display: "flex", gap: 5 }}>
                    <Button size="small" className="button_outlined" onClick={() => openTemplateFunction('Leads')} disabled={display || UserRemovealKeys.length > 0 || UserRemovealKeys1.length > 0 || displayData?.isMailSent === "Yes"}>
                        <EmailTemplateIcon /> {displayData?.leadTemplate ? "Edit Template" : "Add Template"}
                    </Button>
                    {UserRemovealKeys.length > 0 ?
                        <Button size="small" className="gray-button" onClick={() => UserDataRemoved('leads')} disabled={display || displayData?.isMailSent === "Yes"}>
                            <FeatherIcon icon="trash" /> Remove Candidates
                        </Button> :
                        <Button size="small" className="button_colors" onClick={OpenUserTable} disabled={display || UserRemovealKeys1.length > 0 || displayData?.isMailSent === "Yes"}>
                            <FeatherIcon icon="plus-circle" /> Candidates
                        </Button>}
                </div>
            </div>
            <div style={{ margin: "10px 0px 20px" }}>
                <div className="table-bordered leaderboard-table table-responsive CampaignTable-pagination">
                    <Table
                        tableLayout="fixed"
                        onRow={(record) => ({
                            onClick: (e) => {
                                if (
                                    record?.LeadData?.isPresent &&
                                    (e.target.tagName === 'TD' || e.target.tagName === 'DIV' || e.target.tagName === 'FIGCAPTION' || e.target.tagName === 'IMG' || e.target.tagName === 'SPAN') &&
                                    !e.target.closest('.ant-table-selection-column')
                                ) {
                                    ViewDetailPage(record.key, 'LEAD');
                                }
                            },
                            className: record?.LeadData?.isPresent ? 'clickable-row' : 'non-clickable-row',
                        })}
                        showSorterTooltip={false}
                        rowSelection={rowSelection}
                        dataSource={usersTableData.filter(item => UserselectedRowKeys.includes(item.key))}
                        columns={usersTableColumns}
                        // pagination={{
                        //     defaultPageSize: 5,
                        //     total: usersTableData.filter(item => UserselectedRowKeys.includes(item.key)).length,
                        //     showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        // }}
                        pagination={false} // disable pagination
                        scroll={{ y: 270 }}
                    />
                </div>
            </div>
            <Divider />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ fontWeight: "600", fontSize: 16 }}>Selected Residents</div>
                <div style={{ display: "flex", gap: 5 }}>
                    <Button size="small" className="button_outlined" onClick={() => openTemplateFunction('Contacts')} disabled={display || UserRemovealKeys.length > 0 || UserRemovealKeys1.length > 0 || displayData?.isMailSent === "Yes"}>
                        <EmailTemplateIcon /> {displayData?.contactTemplate ? "Edit Template" : "Add Template"}
                    </Button>
                    {UserRemovealKeys1.length > 0 ?
                        <Button size="small" className="gray-button" onClick={() => UserDataRemoved1('contacts')} disabled={display || displayData?.isMailSent === "Yes"}>
                            <FeatherIcon icon="trash" /> Remove Residents
                        </Button> :
                        <Button size="small" className="button_colors" onClick={OpenUserTable1} disabled={display || UserRemovealKeys.length > 0 || displayData?.isMailSent === "Yes"}>
                            <FeatherIcon icon="plus-circle" /> Residents
                        </Button>}
                </div>
            </div>
            <div style={{ margin: "10px 0px 20px" }}>
                <div className="table-bordered leaderboard-table table-responsive CampaignTable-pagination">
                    <Table
                        tableLayout="fixed"
                        onRow={(record) => ({
                            onClick: (e) => {
                                if (
                                    record?.contactData?.isPresent &&
                                    (e.target.tagName === 'TD' || e.target.tagName === 'DIV' || e.target.tagName === 'FIGCAPTION' || e.target.tagName === 'IMG' || e.target.tagName === 'SPAN') &&
                                    !e.target.closest('.ant-table-selection-column')
                                ) {
                                    ViewDetailPage(record.key, 'CONTACT');
                                }
                            },
                            className: record?.contactData?.isPresent ? 'clickable-row' : 'non-clickable-row',
                        })}
                        showSorterTooltip={false}
                        rowSelection={rowSelection1}
                        dataSource={usersTableData1.filter(item => UserselectedRowKeys1.includes(item.key))}
                        columns={usersTableColumns1}
                        // pagination={{
                        //     defaultPageSize: 5,
                        //     total: usersTableData1.filter(item => UserselectedRowKeys1.includes(item.key)).length,
                        //     showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        // }}
                        pagination={false} // disable pagination
                        scroll={{ y: 270 }}
                    />
                </div>
            </div>
            {openUser && <LeadtoCam openUser={openUser} exportData={UserexportData} usersTableColumns={usersTableColumns} filterDatas={UserfilterDatas} OpenUserTable={OpenUserTable} selectedRowKeys={UserselectedRowKeys} setFilterDatas={setUserFilterDatas} displayData={displayData} getCampaignData={getCampaignData} />}
            {openUser1 && <ContecttoCam openUser={openUser1} exportData={UserexportData1} usersTableColumns={usersTableColumns1} filterDatas={UserfilterDatas1} OpenUserTable={OpenUserTable1} selectedRowKeys={UserselectedRowKeys1} setFilterDatas={setUserFilterDatas1} displayData={displayData} getCampaignData={getCampaignData} />}
            {openTemplate && <CampaignTemplate openTemplate={openTemplate} setOpenTemplate={openTemplateFunction} configType={configType} displayData={displayData} getCampaignData={getCampaignData} />}
        </>
    )
}

CamReports.propTypes = {
    allLead: PropTypes.array.isRequired,
    allContact: PropTypes.array.isRequired,
    displayData: PropTypes.object.isRequired,
    getCampaignData: PropTypes.func.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};

export default React.memo(CamReports)